
import ConfigVendorsNotFoundSvgComponent from "../../assets/svg-components/not-found/config-vendors";
import { NavLink } from "react-router-dom";
import './index.scss';


export default function ConfigVendorsNotfound() {
  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details config_vendors_not_found">
          {/* <img
            src="/images/page-not-found/config-vendors.svg"
            className="not-found-image img-fluid not-found-image-config-vendors"
          /> */}
          <div className="not-found-image img-fluid not-found-image-config-vendors">
            <ConfigVendorsNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text no-data-found-text-config-vendors">Vendor not found. Please click the button below to <br /> add a new vendor and sub-vendor.</p>
          <button className='btn btn-primary btn-add-no-record'>
            <NavLink to={`/configuration/vendors/add`} className="d-flex align-items-center color-white" >
              <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="M11 19V13H5V11H11V5H13V11H19V13H13V19Z" fill="#ffffff"></path></svg>
                Add Vendor
            </NavLink>
          </button>
        </div>
      </div>
    </>
  );
}
